/* ═══════════════════════════════════════════════
   Dua Pixels — Popup Logic
   Lead Capture (5%) + Cart Upsell (10%)
   ═══════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── helpers ── */
  function open(el) {
    if (!el) return;
    el.classList.add('is-visible');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close(el) {
    if (!el) return;
    el.classList.remove('is-visible');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function init() {
    var leadPopup   = document.getElementById('dp-lead-popup');
    var upsellPopup = document.getElementById('dp-upsell-popup');

    /* ── close buttons & overlay ── */
    document.querySelectorAll('.dp-popup-close, .dp-popup-dismiss').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        close(e.target.closest('.dp-popup-overlay'));
      });
    });

    /* overlay click = close */
    document.querySelectorAll('.dp-popup-overlay').forEach(function (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close(overlay);
      });
    });

    /* ESC key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.dp-popup-overlay.is-visible').forEach(close);
      }
    });

    /* ═══════════════════════════════════════════
       1. LEAD CAPTURE POPUP — 5% off
       ═══════════════════════════════════════════ */
    if (leadPopup && !localStorage.getItem('dp_lead_captured')) {
      /* show after 5 seconds */
      setTimeout(function () { open(leadPopup); }, 5000);

      var form = document.getElementById('dp-lead-form');
      var msg  = document.getElementById('dp-lead-msg');

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = document.getElementById('dp-lead-email').value.trim();
          var phone = document.getElementById('dp-lead-phone').value.trim();

          if (!email || email.indexOf('@') < 1) {
            msg.textContent = 'Please enter a valid email.';
            msg.className = 'dp-form-msg error';
            return;
          }

          /* Save to Shopify customer list */
          fetch('/contact', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'form_type=customer&utf8=%E2%9C%93'
              + '&contact%5Bemail%5D=' + encodeURIComponent(email)
              + '&contact%5Bphone%5D=' + encodeURIComponent(phone)
              + '&contact%5Btags%5D=popup_lead,discount_5off'
          }).then(function () {
            msg.textContent = 'Use code WELCOME5 at checkout! 🎉';
            msg.className = 'dp-form-msg success';
            localStorage.setItem('dp_lead_captured', '1');
            setTimeout(function () { close(leadPopup); }, 3000);
          }).catch(function () {
            msg.textContent = 'Use code WELCOME5 at checkout! 🎉';
            msg.className = 'dp-form-msg success';
            localStorage.setItem('dp_lead_captured', '1');
            setTimeout(function () { close(leadPopup); }, 3000);
          });
        });
      }
    }

    /* ═══════════════════════════════════════════
       2. CART UPSELL POPUP — 10% extra off
       ═══════════════════════════════════════════ */
    if (upsellPopup && window.DuaPixelsCart && window.DuaPixelsCart.itemCount > 0) {

      /* Intercept ALL checkout triggers */
      function interceptCheckout(e) {
        if (!sessionStorage.getItem('dp_upsell_shown')) {
          e.preventDefault();
          e.stopPropagation();
          open(upsellPopup);
          sessionStorage.setItem('dp_upsell_shown', '1');
        }
      }

      /* Attach to static checkout buttons */
      document.querySelectorAll(
        'form[action="/cart"] button[name="checkout"], form[action="/cart"] input[name="checkout"], a[href="/checkout"]'
      ).forEach(function (btn) {
        btn.addEventListener('click', interceptCheckout, true);
      });

      /* Also watch for dynamically added checkout buttons (cart drawer etc.) */
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            var btns = node.querySelectorAll
              ? node.querySelectorAll('form[action="/cart"] button[name="checkout"], form[action="/cart"] input[name="checkout"], a[href="/checkout"]')
              : [];
            btns.forEach(function (btn) {
              btn.addEventListener('click', interceptCheckout, true);
            });
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });

      /* "Complete Order with 10% Off" */
      var applyBtn = document.getElementById('dp-apply-upsell-btn');
      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          applyBtn.textContent = 'Applying discount...';
          applyBtn.style.opacity = '0.65';
          applyBtn.disabled = true;
          var code = window.DuaPixelsCart.upsellDiscountCode || 'EXTRA10OFF';
          window.location.href = '/checkout?discount=' + encodeURIComponent(code);
        });
      }
    }
  }

  /* boot */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
